import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {
  AgrNotificationEmptyModule,
  AgrPageToolbarModule,
  AgrSummaryCardHorizontalModule,
  AgrSummaryCardModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { HealthSummaryComponent } from './components/health-summary/health-summary.component';
import { HealthYearSummaryComponent } from './components/health-year-summary/health-year-summary.component';
import { SomaticCellCountAttentionsComponent } from './components/somatic-cell-count-attentions/somatic-cell-count-attentions.component';
import { HealthEffects } from './store/effects/health.effects';
import { healthReducer } from './store/reducers/health.reducers';

@NgModule({
  imports: [
    AgrDialogModule,
    MatTableModule,
    MatSortModule,
    AgrFormModule,
    AgrPageToolbarModule,
    AgrSummaryCardModule,
    AgrSummaryCardHorizontalModule,
    AgrNotificationEmptyModule,
    AgrTableModule,
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    SharedModule,
    SomaticCellCountAttentionsComponent,
    HealthSummaryComponent,
    HealthYearSummaryComponent,
  ],
  providers: [provideState('health', healthReducer), provideEffects([HealthEffects])],
})
export class HealthModule {}
